import React from 'react';
import { Heading, Slide, Section, preloader } from 'spectacle-ppa';
import CompleteLevelButton from 'components/completeLevelButton';

import balloonSlide from '../../baseSlides/balloonSlide';
import videoSlide from '../../baseSlides/videoSlide';

import ianSaraLeanSmile from '../../images/characters/ian_sara_lean_smile.png';
import ianSaraSide from '../../images/characters/ian_sara_side.png';
import ianSaraLeanQuestioning from '../../images/characters/ian_sara_lean_questioning.png';
import ianSaraSilly from '../../images/characters/ian_sara_silly.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile from './finish.md';

const md = new MarkdownScript(markdownFile);

import imgLevel1Complete from './level-1_complete.svg';
import imgLevel2Complete from './level-2_complete.svg';
import imgLevel3Complete from './level-3_complete.svg';

const levels = {
  '1': { img: imgLevel1Complete },
  '2': { img: imgLevel2Complete },
  '3': { img: imgLevel3Complete }
};

export function preloadFinish () {
  preloader([
    ianSaraLeanSmile,
    ianSaraSide,
    ianSaraLeanQuestioning,
    ianSaraSilly,
    imgLevel1Complete,
    imgLevel2Complete,
    imgLevel3Complete
  ]);
}

function finishSection ({ level, regionData }) {
  return (
    <Section id="finish">

      {/* Outtakes 1 */}
      { (level === 1) &&
        videoSlide({
          id: 'outtakes',
          notes: md.getSubSectionAsHtml('Outtakes 1', 'Notes', false, regionData),
          youTubeId: md.getSectionMetadata('Outtakes 1', 'YouTube', regionData)
        })
      }

      {/* Outtakes 2 */}
      { (level === 2) &&
        videoSlide({
          id: 'outtakes',
          notes: md.getSubSectionAsHtml('Outtakes 2', 'Notes', false, regionData),
          youTubeId: md.getSectionMetadata('Outtakes 2', 'YouTube', regionData)
        })
      }

      {/* Scoreboard Recap */}
      { (level !==3) &&
        balloonSlide({
          id: 'scoreboard-recap',
          characterSide: 'left',
          characterImage: ianSaraSide,
          html: md.getSubSectionAsHtml('Scoreboard Recap', 'Content', false, regionData),
          notes: md.getSubSectionAsHtml('Scoreboard Recap', 'Notes', false, regionData)
        })
      }

      {/* Earn More Points */}
      { (level !==3) &&
        balloonSlide({
          id: 'earn-more-points',
          characterSide: 'right',
          characterImage: ianSaraLeanQuestioning,
          html: md.getSubSectionAsHtml('Earn More Points', 'Content', false, regionData),
          notes: md.getSubSectionAsHtml('Earn More Points', 'Notes', false, regionData)
        })
      }

      {/* Farewell levels 1 */}
      { (level === 1) &&
        balloonSlide({
          id: 'farewell',
          characterSide: 'left',
          characterImage: ianSaraLeanSmile,
          html: md.getSubSectionAsHtml('Farewell', 'Content', false, regionData),
          notes: md.getSubSectionAsHtml('Farewell', 'Notes', false, regionData)
        })
      }

      {/* Farewell levels 2 */}
      { (level === 2) &&
        balloonSlide({
          id: 'farewell',
          characterSide: 'left',
          characterImage: ianSaraSide,
          html: md.getSubSectionAsHtml('Farewell', 'Content', false, regionData),
          notes: md.getSubSectionAsHtml('Farewell', 'Notes', false, regionData)
        })
      }

      {/* Farewell levels 3 */}
      { (level === 3) &&
        balloonSlide({
          id: 'farewell',
          characterSide: 'left',
          characterImage: ianSaraSilly,
          html: md.getSubSectionAsHtml('Farewell', 'Content', false, regionData),
          notes: md.getSubSectionAsHtml('Farewell', 'Notes', false, regionData)
        })
      }

      {/* Level complete */}
      <Slide
      id="level-completed"
      notes={'<h2>Level ' + level + ' Finished</h2>'}
      bgColor="transparent"
      finish>
        <div className="level-complete">
          <div className="level-complete-content">
              <figure className="level-complete-graphic"><img src={levels[level].img}/></figure>
              <Heading size={2}>
                You've finished
              </Heading>
              <Heading size={2}>
                level {level} of 3
              </Heading>
              <CompleteLevelButton/>
          </div>
        </div>
      </Slide>

    </Section>
  );
}

export default finishSection;



// WEBPACK FOOTER //
// ./programs/epsHybridPrimaries/sections/90_finish/finishSection.jsx